
export class ThirdPartyIntegration {
  stackId: number;
  configurationId: number;
  integrationName: string;
  vendorOption: string;
  vendorType: string;
  iconName: string;
  url: string;
  createdBy: string;
  modifiedBy: string;

  public constructor(init?: Partial<ThirdPartyIntegration>) {
    Object.assign(this, init);
  }
}
